import React from "react";
import shoppingCartIcon from "assets/icons/market/shopping-cart.svg";
import { useCart } from "features/market/context/CartContext";
import LightButton from "shared/ui/LightButton";
import "./CartIcon.css";

const CartIcon = ({ className = "" }) => {
  const { totalItems, toggleCart } = useCart();

  return (
    <div className={`cart-icon-wrapper ${className}`}>
      <LightButton
        onClick={toggleCart}
        ariaLabel={`Shopping cart with ${totalItems} items`}
        iconSrc={shoppingCartIcon}
      />
      {totalItems > 0 && (
        <span className="cart-icon__badge" aria-hidden="true">
          <span className="cart-icon__badge-dot" aria-hidden="true"></span>
          {totalItems > 99 ? "99+" : totalItems}
        </span>
      )}
    </div>
  );
};

export default CartIcon;
